export const getCountries = async () => {
  let data = await fetch(
    "https://restcountries.com/v2/all?fields=name,alpha2Code"
  )
    .then((res) => {
      return res.json();
    })
    .then((d) => {
      return d;
    });
  return data;
};

export const getUserLocation = async () => {
  let data = await fetch(
    "https://ipgeolocation.abstractapi.com/v1/?api_key=4123cd5312bc4ed286a6fc00e1eed3e3&fields=country_code"
  )
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      if (data.error) return;
      if (data.country_code) {
        return data.country_code;
      }
      return "";
    });
  return data;
};

export const SubscribeAsync = async (formdata) => {
  const requestOptions = {
    method: "POST",
    body: formdata,
  };
  let message = await fetch(
    "https://emailapp.leadersinternational.org/subscribe",
    requestOptions
  )
    .then((result) => result.text())
    .then((response) => {
      var subStr = response.match("<h2>(.*)</h2>");
      return subStr[1];
    });
  return message;
};
